import { messageBoardConstants } from '../actions/constants/messageBoardConstants';

const messageBoardData = (state = { status: '', message: '' }, action: any) => {
	switch (action.type) {
		case messageBoardConstants.MessageBoard_GetByFilter_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isAllMessagesLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetByFilter_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isAllMessagesLoaded: true,
				allMessagesData: action.payload.messageBoards
			};
		case messageBoardConstants.MessageBoard_GetByFilter_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isAllMessagesLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetDetail_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isSingleMessageLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetDetail_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isSingleMessageLoaded: true,
				aMessageData: action.payload.messageBoard
			};
		case messageBoardConstants.MessageBoard_GetDetail_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isSingleMessageLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_Save_Request:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isAddOrEditLoaded: false
			};
		case messageBoardConstants.MessageBoard_Save_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isAddOrEditLoaded: true,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_Save_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isAddOrEditLoaded: false,
				status: action.payload
			};
		case messageBoardConstants.MessageBoard_Delete_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case messageBoardConstants.MessageBoard_Delete_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleted:true,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_Delete_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleted: true,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetReport_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isTopPostsLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetReport_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isTopPostsLoaded: true,
				topPostsData: action.payload
			};
		case messageBoardConstants.MessageBoard_GetReport_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isTopPostsLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetTopic_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isTopicsLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetTopic_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isTopicsLoaded: true,
				topicsData: action.payload.topic
			};
		case messageBoardConstants.MessageBoard_GetTopic_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isTopicsLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_TopicDelete_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isTopicDeleted: false
			};
		case messageBoardConstants.MessageBoard_TopicDelete_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isTopicDeleted: true,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_TopicDelete_Failure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isTopicDeleted: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_TopicRestore_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isTopicRestored: false
			}
		case messageBoardConstants.MessageBoard_TopicRestore_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isTopicRestored: true,
				isError: false,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_TopicRestore_Failure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isTopicRestored: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetPostByFilter_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isPostsLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetPostByFilter_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isPostsLoaded: true,
				postsData: action.payload.posts,
			};
		case messageBoardConstants.MessageBoard_GetPostByFilter_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isPostsLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetAlert_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isAlertsLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetAlert_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isAlertsLoaded: true,
				alertsData: action.payload.reportedMessages
			};
		case messageBoardConstants.MessageBoard_GetAlert_Failure:
			return {
				...state,
				isLoading: false,
				isSucces: false,
				isError: true,
				isAlertsLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_PostDelete_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isPostDeleted: false
			};
		case messageBoardConstants.MessageBoard_PostDelete_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isPostDeleted: true,
				isError: false,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_PostDelete_Failure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isPostDeleted: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_PostRestore_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isPostRestored: false
			}
		case messageBoardConstants.MessageBoard_PostRestore_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isPostRestored: true,
				isError: false,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_PostRestore_Failure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isPostRestored: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_PostFlag_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFlagSetLoaded: false
			};
		case messageBoardConstants.MessageBoard_PostFlag_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isFlagSetLoaded: true,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_PostFlag_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isFlagSetLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_PostAuthorization_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFlagApproveOrRejectLoaded: false
			};
		case messageBoardConstants.MessageBoard_PostAuthorization_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isFlagApproveOrRejectLoaded: true,
				status: action.payload.status
			};
		case messageBoardConstants.MessageBoard_PostAuthorization_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isFlagApproveOrRejectLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetReportType_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isMsgReportTypesLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetReportType_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isMsgReportTypesLoaded: true,
				reportTypeResults: action.payload.messageReportTypes,
			};
		case messageBoardConstants.MessageBoard_GetReportType_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isMsgReportTypesLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetCountByYear_Request:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isBoardMessageCountByYearLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetCountByYear_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: false,
				isBoardMessageCountByYearLoaded: true,
				boardMessagesCountByYearData: action.payload,
			};
		case messageBoardConstants.MessageBoard_GetCountByYear_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isBoardMessageCountByYearLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetUserPublicMessage_Request:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserDashboardMsgLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetUserPublicMessage_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: false,
				isUserDashboardMsgLoaded: true,
				userDasboardMessageData: action.payload.dashboardMessages,
				publicMessagesCount: action.payload.totalCount
			};
		case messageBoardConstants.MessageBoard_GetUserPublicMessage_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserDashboardMsgLoaded: false,
				status: action.payload
			};

		case messageBoardConstants.MessageBoard_GetUserChannelMessage_Request:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserDashboardChannelMsgLoaded: false
			};
		case messageBoardConstants.MessageBoard_GetUserChannelMessage_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUserDashboardChannelMsgLoaded: true,
				userDasboardChannelMessageData: action.payload
			};
		case messageBoardConstants.MessageBoard_GetUserChannelMessage_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserDashboardChannelMsgLoaded: false,
				status: action.payload
			};
		default:
			return state;
	}
};

export default messageBoardData;